import { createTheme, DEFAULT_THEME, mergeMantineTheme } from '@mantine/core';

const camGlassTheme = createTheme({
  primaryColor: 'cyan',
  primaryShade: { light: 6, dark: 6 },
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", "Fira Code", monospace',
  headings: {
    fontFamily: '"Outfit", "Inter", sans-serif',
    fontWeight: '700',
  },
  colors: {
    // CamGlass gold accent: #ffbe00 → warm yellow
    gold: [
      '#fff8e1', '#fff3c4', '#ffe888', '#ffd84d',
      '#ffc91a', '#ffbe00', '#e6a800', '#b38400',
      '#806000', '#4d3a00',
    ],
    // CamGlass dark backgrounds: #222
    dark: [
      '#C1C2C5', '#A6A7AB', '#909296', '#5C5F66',
      '#373A40', '#2C2E33', '#25262B', '#1A1B1E',
      '#141517', '#101113',
    ],
  },
  defaultRadius: 'md',
  other: {
    camglassGold: '#ffbe00',
    camglassTeal: '#00aacb',
    camglassGreen: '#1BA449',
  },
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontWeight: 600,
        },
      },
    },
    Card: {
      defaultProps: {
        padding: 'lg',
        radius: 'md',
      },
    },
  },
});

export const theme = mergeMantineTheme(DEFAULT_THEME, camGlassTheme);
